import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sidebar-atricon',
  standalone: false,
  templateUrl: './sidebar-atricon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidebar-atricon.component.css'
})
export class SidebarAtriconComponent {
  isCollapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }
}
